<template>
  <div data-component-group="pin-panels" data-component="thread">
    <div class="thread-image">
      <v-img
        :src="threadImage"
        :lazy-src="threadImage"
        aspect-ratio="1"
        class="bg-white-lighten-2 elevation-0"
        cover
      >
        <template v-slot:placeholder>
          <v-img :src="placeholder" aspect-ratio="1" class="bg-grey-lighten-2" />
        </template>
      </v-img>
    </div>

    <div class="thread-details">
      <div class="thread-title">
        {{ thread.pepper_thread.title }}
      </div>

      <div class="thread-meta">
        <div class="thread-meta-box">
          <v-icon size="small" class="material-icons-outlined">label</v-icon>
          {{ thread.pepper_thread.category }}
        </div>

        <div v-if="hasBusiness" class="thread-meta-box">
          <v-icon size="small" class="material-icons-outlined">store</v-icon>
          {{ thread.business.name }}
        </div>

        <div class="thread-link-box">
          <v-btn variant="text" @click="onViewThread">
            <v-icon size="small">bookmark</v-icon>
            {{ thread.pepper_thread.id }}
            <v-icon>launch</v-icon>
          </v-btn>
        </div>
      </div>

      <panels-tag
        v-if="thread.pepper_thread.expired"
        type="error"
        label="Deal expired"
      />
    </div>
  </div>
</template>

<script>
  import {
    isNull,
    isStr,
    isObj,
    isNum,
    isBool,
    openUrlInNewWindow,
    isUndef,
  } from '../../utils';
  import placeholder from '../../assets/img/placeholder.png';

  export default {
    props: {
      thread: {
        type: Object,
        required: true,
        validator(value) {
          return (
            (isNull(value.end_date) ||
              isUndef(value.end_date) ||
              isStr(value.end_date)) &&
            ((isObj(value.business) && isStr(value.business.name)) ||
              isNull(value.business)) &&
            isObj(value.pepper_thread) &&
            isNum(value.pepper_thread.id) &&
            (isStr(value.pepper_thread.image) ||
              isNull(value.pepper_thread.image)) &&
            isStr(value.pepper_thread.url) &&
            isStr(value.pepper_thread.title) &&
            isStr(value.pepper_thread.category) &&
            isBool(value.pepper_thread.expired)
          );
        },
      },
      showTags: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        placeholder,
        areCommentsOn: false,
      };
    },
    computed: {
      threadImage() {
        return this.hasImage ? this.thread.pepper_thread.image : this.placeholder;
      },
      hasImage() {
        return isStr(this.thread.pepper_thread.image);
      },
      hasBusiness() {
        return isObj(this.thread.business);
      },
    },
    methods: {
      onClick(event) {
        event.stopPropagation();
      },
      onViewThread(event) {
        event.preventDefault();
        event.stopPropagation();
        return openUrlInNewWindow(window.open(), this.thread.pepper_thread.url);
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../assets/styles/theme' as *;

[data-component-group='pin-panels'][data-component='thread'] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  .thread-image {
    width: 90px;
    padding: 0 16px 0 0;

    .v-image {
      max-width: 80px;
      border-radius: $border-radius;
    }
  }

  .thread-details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    width: calc(100% - 80px);
  }

  p {
    font-size: $text-size-sm;
    margin: 0 0 10px 0;

    &:last-child {
      margin: 0;
    }
  }

  .thread-title {
    font-size: $text-size-sm;
    font-weight: bold;
    line-height: 20px;
    letter-spacing: 0.16px;
  }

  .thread-meta {
    align-items: flex-start;
    display: flex;
    gap: 4px;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: 7px;

    > div {
      align-items: center;
      display: flex;
      font-size: 12px;
      height: 27px;
    }

    .thread-link-box {
      height: 40px;
    }
  }

  .thread-link-box {
    align-items: center;
    display: inline-flex;
    justify-content: flex-start;
    text-decoration: none;

    .v-btn {
      padding: 0;
      margin: 0;
      font-size: $text-size-sm;
      font-weight: 500;
      width: auto;
      min-width: auto;

      &:before {
        background-color: transparent !important;
      }
    }

    .v-icon {
      color: var(--c-text-muted);

      &:first-child {
        margin: 0;
      }

      &:last-child {
        margin: 0 0 0 19px;
      }
    }

    a {
      text-decoration: none;
    }
  }
}
</style>
